import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import { getFundstatus } from "../../../Services/Admin/Addmin";
import { UpdatestatusForpaymenthistory, InrUpdatestatusForpaymenthistory, getScreenShot, InrgetScreenshot } from "../../../Services/Admin/Addmin";
import Swal from "sweetalert2";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import { Modal, Button } from "react-bootstrap";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import { getAllClient } from "../../../Services/Superadmin/Superadmin";
import { useLocation } from "react-router-dom";

const Deposit = () => {

  const state = useLocation()


  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;

  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("Pending");
  const [selectedValues, setSelectedValues] = useState({});
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [client, setClient] = useState([]);
  const [activeMarket, setActiveMarket] = useState(state?.state?.item === "rupee" ? "INR" : "USD");

  const [getimage, setGetimage] = useState({})
  const [imageModel, setImageModel] = useState(false)
  const [totalPages, setTotalPages] = useState(1);


  useEffect(() => {
    getallclient()
  }, [])

  useEffect(() => {
    getAllfundsstatus();
  }, [search, activeTab, page, rowsPerPage, activeMarket]);

  const handleSelectChange = async (rowId, row, event) => {
  const status = event.target.value;

  setSelectedValues(prev => ({
    ...prev,
    [rowId]: status,
  }));

  await Updatestatus(rowId, status, row);
};


  const Updatestatus = async (id, status, row) => {
    try {
      const admin_id = user_id;
      const data = { admin_id, id, status, type: "CREDIT", Balance: row.Balance };
      let response;
      if (activeMarket == "INR") {
        response = await InrUpdatestatusForpaymenthistory(data);
      } else {
        response = await UpdatestatusForpaymenthistory(data);
      }

      if (response.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            response.message ||
            "An unexpected error occurred. Please try again.",
          timer: 2000,
        });
        getAllfundsstatus();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            response.message ||
            "Failed to update the request. Please try again.",
          timer: 2000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.message || "An unexpected error occurred. Please try again.",
        timer: 2000,
      });
    }
  };



  const getScreenShotdata = async (value) => {
    try {
      const data = { userid: value.userid, id: value._id };
      let response;
      if (activeMarket === "INR") {
        response = await InrgetScreenshot(data);
      } else {
        response = await getScreenShot(data);
      }
      setGetimage(response?.data?.ScreenShot);
      setImageModel(true);
    } catch (error) {
      console.error("Error fetching screenshot:", error);
    }
  };




  // const columns = [
  //   { Header: "Name", accessor: "FullName" },
  //   {
  //     Header: "Request",
  //     accessor: "type",
  //     Cell: ({ cell }) => (cell.row.type == 1 ? "Deposite" : cell),
  //   },
  //   {
  //     Header: "Balance",
  //     accessor: "Balance",
  //     Cell: ({ cell }) => (
  //       <span>
  //         {activeMarket === "USD" ? "$" : "₹"}{cell.value}
  //       </span>
  //     )
  //   },
  //   { Header: "Transaction Id", accessor: "transactionId" },

  //   {
  //     Header: "Date",
  //     accessor: "createdAt",
  //     Cell: ({ cell }) => fDateTimesec(cell.value),
  //   },
  //    {
  //     Header: "ScreenShot",
  //     accessor: "",
  //     Cell: ({ cell }) => (
  //       <button
  //         className="btn btn-primary btn-sm "
  //         onClick={() => getScreenShotdata(cell.row)}
  //       >
  //         View
  //       </button>
  //     ),
  //   },
  // ];




  // if (activeTab === "Pending" && client.Fund_request == 1) {
  //   columns.push({
  //     Header: "Action",
  //     accessor: "Action",
  //     Cell: ({ cell }) => (
  //       <div>
  //         <select
  //           className="form-select"
  //           onChange={(event) =>
  //             handleSelectChange(cell.row.id, cell.row, event)
  //           }
  //           Value={selectedValues[cell.row.id] || "0"}
  //         >
  //           <option value="0">Pending</option>
  //           <option value="2">Reject</option>
  //           <option value="1">Complete</option>
  //         </select>
  //       </div>
  //     ),
  //   });
  // }

  const columns = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ row, index }) => {
        return (page - 1) * rowsPerPage + (index + 1);
      }
    },
    { Header: "Name", accessor: "FullName" },

    {
      Header: "Request",
      accessor: "type",
      Cell: ({ row }) => (row.type == 1 ? "Deposit" : "Withdraw"),
    },

    {
      Header: "Balance",
      accessor: "Balance",
      Cell: ({ row }) => (
        <span>
          {activeMarket === "USD" ? "$" : "₹"}{row.Balance}
        </span>
      )
    },

    { Header: "Transaction Id", accessor: "transactionId" },

    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ row }) => fDateTimesec(row.createdAt),
    },

    {
      Header: "ScreenShot",
      Cell: ({ row }) => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => getScreenShotdata(row)}
        >
          View
        </button>
      ),
    },
  ];

  if (activeTab === "Pending" && client.Fund_request == 1) {
    columns.push({
      Header: "Action",

      Cell: ({ row }) => (
        <select
          className="form-select"
          value={selectedValues[row._id] || "0"}
          onChange={(e) => handleSelectChange(row._id, row, e)}

        >
          <option value="0">Pending</option>
          <option value="2">Reject</option>
          <option value="1">Complete</option>
        </select>
      ),
    });
  }




  const getallclient = async () => {
    try {
      const data = { userid: user_id };
      const response = await getAllClient(data);
      if (response.status) {

        setClient(response.data);
      }
    } catch (error) { }
  };





  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };



  const getAllfundsstatus = async () => {
    try {
      setLoading(true);

      const data = {
        adminid: user_id,
        type: 1,
        activeTab,
        page,
        limit: rowsPerPage,
        search,
        market: activeMarket
      };
      const response = await getFundstatus(data);

      if (response.status) {
        const filtertype = response.data || [];
        setData(filtertype);
        setTotalPages(response?.pagination?.totalPages || 0);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };




  const handlePageChange = (newPage) => {
    if (newPage < 1) return;
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newLimit) => {
    setRowsPerPage(newLimit);
    setPage(1); // reset page when limit changes
  };


  const renderTable = (status) => {
    return (
      <div className="table-responsive shadow-lg">
        <div className="mb-4 ms-4 mt-2">
          <label className="form-label">🔍 Search:</label>
          <input
            className=" input-search form-control"
            style={{ width: "30%" }}
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value)
              setPage(1);
            }}
          />
        </div>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <h5 className="mb-4 ms-4 fw-semibold">{activeTab} Transactions</h5>
            <Table
              columns={columns}
              data={data}
              page={page}
              totalPages={totalPages}
              initialRowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
            />
            <div
              className="d-flex justify-content-between align-items-center px-3 py-2"
              style={{ marginBottom: "20px" }}
            >



              {/* <div className="d-flex align-items-center">
                <span>Rows per page:</span>
                <select
                  className="form-select ms-2"
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(Number(e.target.value))}
                  style={{ width: "auto" }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div> */}

            
            
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="row">
        <div className="demo-view">
          <div className="container-fluid mt-5">
            <div className="row">
              <div className="col-xl-12">
                <div className="card dz-card" id="nav-pills">
                  <div className="card-header flex-wrap border-0">
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <h4 className="card-title">Deposit History</h4>
                      <div className="wallet-tabs">
                        <div className="btn-group" role="group">

                          {TokenData?.market.includes(0) && <button
                            type="button"
                            className={`btn ${activeMarket === "USD" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setActiveMarket("USD")}
                          >
                            <i className="fas fa-dollar-sign me-2"></i>
                            USD Wallet
                          </button>}

                          {TokenData?.market.includes(1) && <button
                            type="button"
                            className={`btn ${activeMarket === "INR" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setActiveMarket("INR")}
                          >
                            <i className="fas fa-rupee-sign me-2"></i>
                            INR Wallet
                          </button>}

                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body pt-3">


                    {/* Nav Pills for Status */}
                    {/* <ul className="nav nav-pills nav-pills1 mb-4 light">
                      {["Pending", "Complete", "Reject"].map((tab, index) => (
                        <li className="nav-item" key={tab}>
                          <a
                            href={`#navpills-${index + 1}`}
                            className={`nav-link navlink ${activeTab === tab ? "active" : ""}`}
                            data-bs-toggle="tab"
                            onClick={() => handleTabClick(tab)}
                          >
                            {tab}
                          </a>
                        </li>
                      ))}
                    </ul> */}
                    <ul className="seg-tabs w-full">
                      {["Pending", "Complete", "Reject"].map((tab, index) => (
                        <li className="w-100" key={tab}>
                          <button
                            className={`seg-item w-100 border-0 ${activeTab === tab ? "active" : ""}`}
                            onClick={() => handleTabClick(tab)}
                          >
                            {tab}
                          </button>
                        </li>
                      ))}
                    </ul>


                    <div className="tab-content">
                      {["Pending", "Complete", "Reject"].map((tab, index) => (
                        <div
                          key={tab}
                          id={`navpills-${index + 1}`}
                          className={`tab-pane ${activeTab === tab ? "active" : ""}`}
                        >
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="card transaction-table">
                                <div className="card-body p-0">
                                  {/* Render Table */}
                                  {renderTable(index)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={imageModel}
        onHide={() => setImageModel(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Screenshot</Modal.Title>
        </Modal.Header>

        <Modal.Body className="overflow-auto" style={{ maxHeight: "70vh" }}>
          {getimage.length > 0 ? (
            <img
              src={getimage?.startsWith("data:image") ? getimage : `data:image/png;base64,${getimage}`}
              alt="Screenshot"
              className="img-fluid rounded"
            />
          ) : (
            <p>No image available</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setImageModel(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};


export default Deposit;